export const StringArray = [String, Array]
export const SNA = [Number, String, Array, Object]
export const StringNumber = [String, Number]
export const ObjectArray = [Object, Array]
export const ObjectFunction = [Object, Function]
